export const XP_WALLPAPER = {
  id: 'xp-bliss',
  url: '/custom/wallpapers/wallpaper-xp-bliss.png',
};

export const ROTATING_WALLPAPERS = [
  {
    id: 'wallpaper-01',
    url: '/custom/wallpapers/wallpaper-01.jpeg',
  },
  {
    id: 'wallpaper-02',
    url: '/custom/wallpapers/wallpaper-02.png',
  },
  {
    id: 'wallpaper-03',
    url: '/custom/wallpapers/wallpaper-03.jpg',
  },
  {
    id: 'wallpaper-04',
    url: '/custom/wallpapers/wallpaper-04.jpg',
  },
  {
    id: 'wallpaper-05',
    url: '/custom/wallpapers/wallpaper-05.png',
  },
  {
    id: 'wallpaper-06',
    url: '/custom/wallpapers/wallpaper-06.jpeg',
  },
  {
    id: 'wallpaper-07',
    url: '/custom/wallpapers/wallpaper-07.jpg',
  },
  {
    id: 'wallpaper-08',
    url: '/custom/wallpapers/wallpaper-08.jpg',
  },
  {
    id: 'wallpaper-09',
    url: '/custom/wallpapers/wallpaper-09.jpg',
  },
  {
    id: 'wallpaper-10',
    url: '/custom/wallpapers/wallpaper-10.jpg',
  },
  {
    id: 'wallpaper-11',
    url: '/custom/wallpapers/wallpaper-11.jpg',
  },
  {
    id: 'wallpaper-12',
    url: '/custom/wallpapers/wallpaper-12.jpg',
  },
  {
    id: 'wallpaper-13',
    url: '/custom/wallpapers/wallpaper-13.jpg',
  },
  {
    id: 'wallpaper-14',
    url: '/custom/wallpapers/wallpaper-14.jpg',
  },
  {
    id: 'wallpaper-15',
    url: '/custom/wallpapers/wallpaper-15.jpg',
  },
  {
    id: 'wallpaper-16',
    url: '/custom/wallpapers/wallpaper-16.jpg',
  },
  {
    id: 'wallpaper-17',
    url: '/custom/wallpapers/wallpaper-17.jpg',
  },
];
